import { CloseCircleOutlined } from '@ant-design/icons';

import styles from './styles.module.css';

type NotAuthorizedMessageProps = {
  open: boolean;
};

const NotAuthorizedMessage = ({ open }: NotAuthorizedMessageProps) => {
  if (!open) {
    return null;
  }

  return (
    <div className={styles.container}>
      <CloseCircleOutlined className={styles.icon} />
      <p className={styles.text}>Entrada Não Autorizada</p>
    </div>
  );
};

export default NotAuthorizedMessage;
